// 获取视频列表
export const GETVIDEOLIST = 'get-video-list'
// 获取视频详情
export const GETVIDEOCONTEXT = 'get-video-context'
// 获取 根据标签 推荐视频
export const GETVIDEOLISTBYTAGS = 'get-video-list-by-tags'
// 获取推荐视频
export const GETVIDEORECOMMENDLIST = 'get-video-recommend-list'
// 获取24H热门视频
export const GETVIDEOHOTLIST = 'get-video-hot-list'
// 获取视频频道列表
export const GETVIDEOCHANNELS = 'get-video-channels'
// 获取相关视频
export const GETVIDEORELATED = 'get-video-related'
